import React, { useState, useEffect, useRef } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { getAlertList } from '../network/get_alartlist';
import dayjs from 'dayjs';
import 'dayjs/locale/ko';
import relativeTime from 'dayjs/plugin/relativeTime';
import { MdArrowBackIos } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';
import { getAlertRead } from '../network/get_alert_read';

dayjs.extend(relativeTime);
dayjs.locale('ko');

const PAGE_SIZE = 15;

function Alert_center() {
  const navigate = useNavigate();

  const [alertData, setAlertData] = useState(null);
  const [items, setItems] = useState([]);
  const [hasMore, setHasMore] = useState(true);
  const [nextPageKey, setNextPageKey] = useState(0); // offset

  const [modalNotice, setModalNotice] = useState(null);

  const NoticeModal = ({ notice, onClose }) => {
  if (!notice) return null;

  return (
    <div style={styles.modalOverlay}>
      <div style={styles.modalContent}>
        <div style={styles.modalHeader}>
          <h2 style={{ margin: 0, fontSize: '18px' }}>{notice.title}</h2>
          <button
            onClick={onClose}
            style={{
              background: 'none',
              border: 'none',
              fontSize: '24px',
              cursor: 'pointer',
            }}
          >
            ×
          </button>
        </div>
        <div style={styles.modalBody}>
          {/* HTML 본문을 그대로 렌더링 */}
          <div dangerouslySetInnerHTML={{ __html: notice.content }} />
        </div>
      </div>
    </div>
  );
};

// “자세히” 클릭 핸들러
const openNoticeDetail = (notice) => {
  setModalNotice(notice);
};

// 모달 닫기
const closeModal = () => setModalNotice(null);

  // 최초 로딩 & 로그인 처리
  const loadFirst = async () => {
    const savedToken = localStorage.getItem('user');
    if (!savedToken) {
      // temp 로그인 등 필요하면 여기서 처리
      // await loginPost("temp", "temp_user");
    }

    const res = await getAlertList(0, PAGE_SIZE);
    console.log(res.results)
    setAlertData(res);
    setItems(res.results || []);
    for (let i = 0; i < res.results.length; i++) {
        getAlertRead(res.results[i].id)
  }
    setNextPageKey(PAGE_SIZE);
    setHasMore(res.next !== null);
  };

  // 추가 페이지 로드
  const loadMore = async () => {
    if (!hasMore) return;

    const res = await getAlertList(nextPageKey, PAGE_SIZE);
    setItems((prev) => [...prev, ...(res.results || [])]);
        for (let i = 0; i < res.results.length; i++) {
        getAlertRead(res.results[i].id)
  }
    setNextPageKey(nextPageKey + PAGE_SIZE);
    setHasMore(res.next !== null);
  };

  useEffect(() => {
    loadFirst();
  }, []);

  // 알림 타입에 따라 표시할 텍스트 반환
  const getAlertMessage = (noti) => {

    switch (noti.type) {
      case 'notice_and_event':
        if (!noti.notice) return '[알림] 내용 없음';
        const title = noti.notice.title || '';
        const prefix = noti.notice.is_top ? '[공지] ' : '';
        return prefix + title;

      case 'highscore_dailylook_estimation':
        // 현재 예시 데이터엔 actor 가 비어있고 new_actor 에 username 있음
        const username = noti.new_actor?.username || noti.actor || '알 수 없음';
        return `${username}님이 내 코디에 높은 점수를 줬습니다.`;

      // 아래는 추후 필요 시 추가하면 되는 케이스들
      case 'like_my_dailylook':
        return `${noti.new_actor?.username || noti.actor}님이 내 코디를 찜했습니다.`;
      case 'new_dailylook_comment':
        return `${noti.new_actor?.username || noti.actor}님이 내 데일리룩에 댓글을 달았습니다.`;
      case 'following':
        return `${noti.new_actor?.username || noti.actor}님이 팔로우했습니다.`;
      case 'chat_receiving':
        return `${noti.new_actor?.username || noti.actor}님이 대화요청을 수락했습니다.`;
      case 'new_title':
        return `새로운 칭호가 부여되었습니다`;
      case 'matching':
        return `매칭되었습니다`;

      // 기타 기본 케이스
      default:
        return noti.notice?.title || noti.data?.title || '새로운 알림';
    }
  };

  const notiClick = (noti) => {
    if(noti.type == 'following' || noti.type == 'new_title'){
          const queryParams = new URLSearchParams({
      id: noti.new_actor.id,
    }).toString();
    // /detail 경로로 인자를 포함하여 GET 방식으로 이동
    navigate(`/my`);
    }else if(noti.type == "highscore_dailylook_estimation" || noti.type == "like_my_dailylook" || noti.type == 'new_dailylook_comment'){
          const queryParams = new URLSearchParams({
      id: noti.data.dailylook_id,
      category: 'd'
    }).toString();

    // /detail 경로로 인자를 포함하여 GET 방식으로 이동
    navigate(`/dailylook?${queryParams}`);

    }else if(noti.type == 'matching'){
      alert('앱에서 확인해주세요')
    }
    console.log(noti)
  }

  const goBack = () => navigate(-1);

  if (!alertData) {
    return (
      <div style={styles.mobileContainer}>
        <div style={{ paddingTop: 80, textAlign: 'center' }}>로딩 중...</div>
      </div>
    );
  }

  return (
    <div style={styles.mobileContainer}>
      {/* 헤더 */}
      <header style={styles.header}>
        <div style={styles.headerContent}>
          <MdArrowBackIos size={24} onClick={goBack} style={{ cursor: 'pointer' }} />
          <span style={{ fontWeight: 700, fontSize: '17px' }}>알림 센터</span>
          <div style={{ width: 30 }} />
        </div>
        <div style={styles.divider} />
      </header>

      {/* 알림 리스트 */}
      <div style={{ paddingTop: 70 }}>
        <InfiniteScroll
          dataLength={items.length}
          next={loadMore}
          hasMore={hasMore}
          loader={<p style={{ textAlign: 'center', padding: '20px' }}>불러오는 중...</p>}
          endMessage={<p style={{ textAlign: 'center', padding: '20px', color: '#888' }}>모든 알림을 확인했습니다.</p>}
        >
          {items.map((noti) => (
            <div
              key={noti.id}
              style={{
                ...styles.alertItem,
                backgroundColor: noti.is_read ? '#ffffff' : '#fff8f8', // 안 읽은 건 살짝 붉은 배경
              }}
              onClick={() => notiClick(noti)}
            >
              {/* 좌측 원형 아이콘 (임시) */}
              <div style={styles.alertIcon}>
                {noti.type === 'notice_and_event' && noti.notice?.is_top ? '공지' : '알림'}
              </div>

              <div style={{ flex: 1 }}>
                <div
                  style={{
                    fontSize: '14px',
                    color: noti.is_read ? '#333' : '#000',
                    fontWeight: noti.is_read ? 'normal' : '600',
                    lineHeight: '1.4',
                  }}
                >
                  {getAlertMessage(noti)}
                </div>

                <div style={{ fontSize: '12px', color: '#999', marginTop: '4px' }}>
                  <TimeAgo isoString={noti.created_at} />
                </div>
              </div>

              {/* 공지글 클릭 시 상세 페이지로 이동하거나 웹뷰 열기 등 필요하면 추가 */}
              {noti.type === 'notice_and_event' && noti.notice && (
                <div
    onClick={() => openNoticeDetail(noti.notice)}
    style={{
      fontSize: '12px',
      color: '#0066ff',
      marginLeft: '10px',
      cursor: 'pointer',
      textDecoration: 'underline',
    }}
  >
    자세히
  </div>
              )}
            </div>
          ))}
        </InfiniteScroll>
      </div>
      <NoticeModal notice={modalNotice} onClose={closeModal} />
    </div>
  );
}

// 간단한 시간 표시 컴포넌트
const TimeAgo = ( isoString) => {
  const timeAgoText = dayjs(isoString).fromNow();
  return <span>{timeAgoText}</span>;
};

// 스타일
const styles = {

   modalOverlay : {
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: 'rgba(0,0,0,0.5)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 1000,
},

 modalContent : {
  background: '#fff',
  width: '90%',
  maxWidth: '420px',
  maxHeight: '80vh',
  borderRadius: '12px',
  overflow: 'hidden',
  boxShadow: '0 4px 20px rgba(0,0,0,0.2)',
},

 modalHeader : {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '16px 20px',
  borderBottom: '1px solid #eee',
},

 modalBody :{
  padding: '20px',
  overflowY: 'auto',
  maxHeight: 'calc(80vh - 60px)',
  lineHeight: '1.6',
  fontSize: '14px',
},
  
  mobileContainer: {
    maxWidth: '420px',
    margin: '0 auto',
    backgroundColor: '#fff',
    minHeight: '100vh',
  },
  header: {
    position: 'fixed',
    top: 0,
    left: '50%',
    transform: 'translateX(-50%)',
    width: '100%',
    maxWidth: '420px',
    backgroundColor: '#fff',
    zIndex: 10,
    padding: '20px 0 0',
  },
  headerContent: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '0 15px',
  },
  divider: {
    height: '1px',
    backgroundColor: '#eee',
    marginTop: '15px',
  },
  alertItem: {
    display: 'flex',
    alignItems: 'flex-start',
    padding: '15px',
    borderBottom: '1px solid #f1f1f1',
  },
  alertIcon: {
    width: 36,
    height: 36,
    borderRadius: '50%',
    backgroundColor: '#ff4d4f',
    color: '#fff',
    fontSize: '11px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: '12px',
    flexShrink: 0,
  },
};

export default Alert_center;